// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import {roles} from '../../roles';
import './UserForm.css';

export type Props = {
  user: ?any,
  onUserChange: Function,
  onActivation?: Function,
};

const UserForm = ({onUserChange, onActivation, user}: Props) => (
  <div className="UserForm">
    <form>
      <div className="content-section box">
        <Field
          name="person.name"
          label="Namn"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="person.address"
          label="Adress"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="person.phone"
          label="Telefon"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="person.mobile"
          label="Mobiltelefon"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="username"
          label="Användarnamn"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="email"
          label="Email"
          onChange={onUserChange}
          component={BasicFormInput}
          type="text" />
        <Field
          name="password"
          label="Lösenord"
          onChange={onUserChange}
          component={BasicFormInput}
          type="password" />
        <Field
          name="password_confirmation"
          label="Repetera lösenord"
          onChange={onUserChange}
          component={BasicFormInput}
          type="password" />
        <Field
          name="role"
          label="Roll"
          normalize={value => value ? value.id : null}
          onChange={onUserChange}
          component={SelectFormInput}
          valueKey="id"
          labelKey="label"
          options={roles} />
        {!!user &&
          <div>
            <label>Aktiveringslänk skickad</label>
            <div className="input-margin">
              {user.notified ? 'Ja' : 'Nej'}
            </div>
          </div>
        }
        {!!onActivation &&
          <button
            className="button"
            type="button"
            onClick={onActivation}>
            Skicka aktiveringslänk
          </button>
        }
      </div>
    </form>
  </div>
);

export default reduxForm({
  form: 'user',
  enableReinitialize: true,
})(UserForm);



// WEBPACK FOOTER //
// ./src/components/UserForm/UserForm.js